
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import axios from "axios";
import validator from "validator";
import store, { RootState } from "store";
import ButtonRightIconGreen from "modules/Common/Components/ButtonRightIconGreen";
import Checkbox from "modules/Common/Components/Checkbox";
import Input from "modules/Common/Components/Input";
import ConfirmDialog from "modules/Common/Components/ConfirmDialog";
// icons + utils
import Xiq from "../../../assets/img/PublishMenu/Xiq.png";
import Cross from "../../../assets/img/icons/cross.svg";
import RssIcon from "../../../assets/img/icons/RssGrey.svg";
import Reload from "../../../assets/img/icons/reload.svg";
import Web from "../../../assets/img/icons/Web.svg";
import Search from "../../../assets/img/icons/search.svg";
import Info from "../../../assets/img/icons/Info.svg";
import Twitter from "../../../assets/img/icons/ArticlePopover/twitterGrayUpsize.svg";
import { SEARCH_ARTICLES } from "constants/actionTypes";
import { getURLDomainName } from "utils";
import { Button } from "antd";


interface IExcludeContent {
  subTextWithInfoIcon?: string;
}

const ExcludeContent: React.FC<IExcludeContent> = (props) => {
  const { subTextWithInfoIcon } = props;
  const [listItems, setListItems] = useState<any[]>([]);
  const [searchListItems, setSearchListItems] = useState<any[]>([]);
  const [inputValue, setInputValue] = useState<string>("");
  const [itemCount, setItemCount] = useState<number>(0);
  const [showConfirm, setShowConfirm] = useState<boolean>(false);
  const [checked, setChecked] = useState<boolean>(false);
  const [showSearchField, setShowSearchField] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [showSearchResults, setShowSearchResults] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>("Invalid entry");
  const [renderUnselectAllButton, setRenderUnselectAllButton] = useState<boolean>(false);
  const [firstTimeLoad, setFirstTimeLoad] = useState<boolean>(true);
  const [allListItemsUnchecked, setAllListItemsUnchecked] = useState<boolean>(false);

  const excludeSourcesReducer = useSelector((state: RootState) => state.assets.excludeSources);
  const sourcedContent = useSelector((state: RootState) => state.searchArticles.sourcedContent);
  // console.log(excludeSourcesReducer);
  const regex = /^([0-9A-Za-z\s\-]+?\.){0,1}[0-9A-Za-z\s\-]+$/;

  useEffect(() => {
    // if (excludeSourcesReducer.length > 0) {
    setListItems(excludeSourcesReducer);
    setItemCount(excludeSourcesReducer.length);
    store.dispatch({
      type: SEARCH_ARTICLES.EXCLUDE_CONTENT,
      payload: excludeSourcesReducer,
    });
    // }
  }, [excludeSourcesReducer]);
  useEffect(() => {
    if (firstTimeLoad && listItems.length > 0) {
      checkedItemsCount();
      setFirstTimeLoad(false);
    }
  }, [listItems]);

  const addListItemHandler = () => {
    const value: string = inputValue.trim();
    setShowSearchField(false);
    setShowSearchResults(false);
    setSearchValue("");
    if (value.startsWith("*.")) {
      if (regex.test(value.substring(2))) handleAddItem("domain");
      else handleError("Invalid TLD");
    } else {
      if (validator.isURL(value) && !value.toLowerCase().includes('twitter')) {
        let searchUrl = "";
        if (value.includes("http")) {
          searchUrl = value;
        } else {
          const domainName = getURLDomainName(value);
          searchUrl = `https://www.${domainName}`;
        }
        axios
          .get(searchUrl)
          .then((res) => {
            if (res.headers["content-type"].includes("xml")) {
              handleAddItem("rss");
            } else {
              handleAddItem("domain");
            }
          })
          .catch((err) => {
            handleAddItem("domain");
          });
      }
      // else if (value.startsWith("@")) handleAddItem("twitter");
      else {
        handleError();
      }
    }
  };

  const handleError = (msg?: string) => {
    setError(true);
    setInputValue("");
    setErrorMsg(msg ? msg : "Invalid entry");
    setTimeout(() => {
      setError(false);
    }, 3000);
  };
  const valueAlreadyExistsInListItems = (value: string) => {
    // function to check if input value is already present in the list
    // if (value.startsWith("@")) value = value.substring(1);
    return listItems.some(function (el: any) {
      return el.data.trim().toLowerCase() === value.trim().toLowerCase();
    });
  };
  const handleAddItem = (type: string) => {
    const value: string = inputValue.trim();
    let checkIfItemExistsInInclude: any = false;
    sourcedContent.forEach(({ data, type }) => {
      let checkVar = value;
      // if (type === "twitter") {
      //   if (data === checkVar.substring(1)) checkIfItemExistsInInclude = true;
      // }
      if (type === "domain") {
        if (data === getURLDomainName(value)) checkIfItemExistsInInclude = true;
      } else if (type === "rss") {
        if (data === checkVar) checkIfItemExistsInInclude = true;
      }
    });
    let itemalreadyExistsInListItem: boolean = false;
    listItems.forEach(({ data, type }) => {
      let checkVar = value;
      // if (type === "twitter") {
      //   if (data === checkVar.substring(1)) itemalreadyExistsInListItem = true;
      // }
      if (type === "domain") {
        if (data === getURLDomainName(value)) itemalreadyExistsInListItem = true;
      } else if (type === "rss") {
        if (data === checkVar) itemalreadyExistsInListItem = true;
      }
    });
    // Multiple @ check
    let itemContainsInvalidInput: boolean = false;
    const new_value = value.substring(1);
    const isValidInput = new_value.includes("@");
    if (isValidInput) itemContainsInvalidInput = true;
    // Error generation
    if (checkIfItemExistsInInclude) {
      handleError("Item already exists in include list");
    } else if (itemalreadyExistsInListItem) {
      handleError("Item already exists");
    } else if (itemContainsInvalidInput || new_value.length === 0) {
      handleError("Invalid twitter handle");
    } else {
      // if (!valueAlreadyExistsInListItems(value)) {
      setError(false);
      setListItems([
        ...listItems,
        {
          // data: type === "domain" ? getURLDomainName(value) : type === "twitter" ? value.substring(1) : value,
          data: type === "domain" ? getURLDomainName(value) : value,
          is_active: true,
          type: type,
        },
      ]);
      setItemCount(itemCount + 1);
      checkIfAllItemsChecked([
        ...listItems,
        {
          // data: type === "domain" ? getURLDomainName(value) : type === "twitter" ? value.substring(1) : value,
          data: type === "domain" ? getURLDomainName(value) : value,
          is_active: true,
          type: type,
        },
      ]);
      store.dispatch({
        type: SEARCH_ARTICLES.EXCLUDE_CONTENT,
        payload: [
          ...listItems,
          {
            // data: type === "domain" ? getURLDomainName(value) : type === "twitter" ? value.substring(1) : value,
            data: type === "domain" ? getURLDomainName(value) : value,
            is_active: true,
            type: type,
          },
        ],
      });
      // } else {
      //   handleError("Item already exists");
      // }
      setInputValue("");
    }
  };
  const inputFieldChangeHandler = (e: any) => {
    setInputValue(e.target.value.trim());
  };
  const deleteAllHandler = () => {
    if (listItems.length > 0) setShowConfirm(true);
  };
  const handleDeleteAllListItems = () => {
    const duplicateList = listItems.filter((item) => item.is_active === false);
    setListItems(duplicateList);
    setItemCount(duplicateList.length);
    setShowConfirm(false);
    store.dispatch({
      type: SEARCH_ARTICLES.EXCLUDE_CONTENT,
      payload: duplicateList,
    });
  };
  const handleCancelDeleteAllListItems = () => {
    setShowConfirm(false);
  };
  const deleteCurrentListItem = (index: number) => {
    const newListItems = [...listItems];
    newListItems.splice(index, 1);
    setListItems(newListItems);
    setItemCount(itemCount - 1);
    store.dispatch({
      type: SEARCH_ARTICLES.EXCLUDE_CONTENT,
      payload: newListItems,
    });
    checkIfAllItemsChecked(newListItems);
  };
  const deleteSearchListItem = (name: string) => {
    const newListItems = [...listItems];
    let itemIndex = -1;
    newListItems.map((item, index) => {
      if (item.data === name) itemIndex = index;
    });
    newListItems.splice(itemIndex, 1);
    setListItems(newListItems);
    const arr = searchListItems.filter((item) => item.data !== name);
    setSearchListItems(arr);
    setItemCount(itemCount - 1);
    store.dispatch({
      type: SEARCH_ARTICLES.EXCLUDE_CONTENT,
      payload: newListItems,
    });
  };

  const selectAllHandler = () => {
    // setChecked(true);
    const listItems2 = listItems.map((item: any) => {
      item.is_active = true;
      return item;
    });
    setListItems([...listItems2]);
    setRenderUnselectAllButton(true);
    setAllListItemsUnchecked(false);
    store.dispatch({
      type: SEARCH_ARTICLES.EXCLUDE_CONTENT,
      payload: [...listItems2],
    });
  };
  const UnselectAllHandler = () => {
    // setChecked(true);
    const listItems2 = listItems.map((item: any) => {
      item.is_active = false;
      return item;
    });
    setListItems([...listItems2]);
    setRenderUnselectAllButton(false);
    setAllListItemsUnchecked(true);
    store.dispatch({
      type: SEARCH_ARTICLES.EXCLUDE_CONTENT,
      payload: [...listItems2],
    });
  };
  const searchIconHandler = () => {
    setShowSearchField(true);
    setShowSearchResults(true);
    setSearchListItems(listItems);
  };
  const searchInputFieldChangeHandler = (e: any) => {
    setSearchValue(e.target.value);
    const newSearchList = listItems.filter((item: any) => item.data.includes(e.target.value));
    setSearchListItems(newSearchList);
    setItemCount(newSearchList.length);
    if (e.target.value.length === 0) {
      setSearchListItems(listItems);
      setItemCount(listItems.length);
    }
  };
  const closeSearchField = () => {
    setShowSearchField(false);
    setShowSearchResults(false);
    setSearchValue("");
    setSearchListItems([]);
    checkedItemsCount();
    setItemCount(listItems.length);
  };
  const checkedItemsCount = () => {
    let allItemsChecked = true;
    listItems.map((item: any) => {
      if (!item.is_active) {
        allItemsChecked = false;
      }
    });
    if (!allItemsChecked) setRenderUnselectAllButton(false);
    else setRenderUnselectAllButton(true);
  };

  const checkIfAllItemsChecked = (list: any) => {
    let allItemsUnchecked = true;
    list.map((item: any) => {
      if (item.is_active) {
        allItemsUnchecked = false;
      }
    });
    setAllListItemsUnchecked(allItemsUnchecked);
  };
  return (
    <Wrapper showSearchField={showSearchField}>
      <div className="d-flex justify-content-between align-items-center" style={{ position: "relative" }}>
        <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
          <p className="heading" data-qa="qa-exclude-content">
            Exclude content:
            {!showSearchField &&
              <span className="search-cover">
                <img style={{ cursor: "pointer" }} onClick={searchIconHandler} src={Search} />
              </span>
            }
          </p>
          {showSearchField &&
            <div className="open-search">
              <img src={Reload} className="reload" />
              <Input
                onChange={(e: any) => searchInputFieldChangeHandler(e)}
                label={null}
                type="text"
                searchField
                value={searchValue}
                placeholder="Search Content"
              />
              <img
                onClick={closeSearchField}
                className="cross"
                style={{ cursor: "pointer", position: "absolute", right: "1em", top: "0.3em" }}
                src={Cross}
                width="14"
              />
            </div>
          }
        </div>
        {!showSearchField &&
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '65%' }}>
            {renderUnselectAllButton ? (
              <p
                className={`green-text ${listItems.length === 0 ? "disable-item" : ""}`}
                onClick={UnselectAllHandler}
              >
                Unselect all
              </p>
            ) : (
              <p
                className={`green-text ${listItems.length === 0 ? "disable-item" : ""}`}
                onClick={selectAllHandler}
              >
                Select all
              </p>
            )}
            &nbsp; &nbsp;
            <p
              className={`red-text ${listItems.length === 0 || allListItemsUnchecked ? "disable-item" : ""}`}
              onClick={deleteAllHandler}
            >
              Delete all
            </p>
          </div>
        }
      </div>
      <div className="list">
        {listItems.length > 0 && <div className="list-count">{itemCount} total</div>}
        <ul>
          {showSearchResults ? (
            searchValue.length > 0 && searchListItems.length === 0 ? (
              <p>No results found</p>
            ) : (
              searchListItems.map((item: any, index) => {
                let icon = item.type === "rss" ? RssIcon : item.type === "domain" ? Web : Twitter;

                return (
                  <li key={index} data-id="qa-li-excluded">
                    <Checkbox
                      checked={item.is_active}
                      onChange={(event: any) => {
                        let value = item.is_active;
                        let listItems2 = [...searchListItems];
                        listItems2[index].is_active = !value;
                        setSearchListItems([...listItems2]);
                        // setListItems([...listItems2]);
                        store.dispatch({
                          type: SEARCH_ARTICLES.EXCLUDE_CONTENT,
                          payload: [
                            // { data: "xiQ Global Pool", is_active: checked, type: "global" },
                            ...listItems,
                          ],
                        });
                      }}
                    />
                    <img src={icon} alt="" />
                    &nbsp;&nbsp;
                    <span className="text-style" data-ia="qa-excluded">
                      {item.data}
                    </span>{" "}
                    &nbsp;
                    <img
                      onClick={() => deleteSearchListItem(item.data)}
                      style={{ cursor: "pointer" }}
                      src={Cross}
                      alt=""
                      width="15"
                      height="15"
                    />
                  </li>
                );
              })
            )
          ) : (
            listItems.map((item: any, index) => {
              let icon = item.type === "rss" ? RssIcon : item.type === "domain" ? Web : Twitter;
              return (
                <li key={index} data-id="qa-li-excluded">
                  <Checkbox
                    checked={item.is_active}
                    onChange={(event: any) => {
                      let value = item.is_active;
                      let listItems2 = [...listItems];
                      listItems2[index].is_active = !value;
                      setListItems([...listItems2]);
                      store.dispatch({
                        type: SEARCH_ARTICLES.EXCLUDE_CONTENT,
                        payload: [...listItems2],
                      });
                      checkIfAllItemsChecked([...listItems2]);
                      checkedItemsCount();
                    }}
                  />
                  <img src={icon} alt="" />
                  &nbsp;&nbsp;
                  <span className="text-style">{item.data}</span> &nbsp;
                  <img
                    onClick={() => deleteCurrentListItem(index)}
                    style={{ cursor: "pointer" }}
                    src={Cross}
                    alt=""
                    width="15"
                    height="15"
                  />
                </li>
              );
            })
          )}
        </ul>
      </div>
      <div className="d-flex justify-content-between mb-2 mt-2 not-label" style={{ width: '100%' }}>
        <Input
          label={null}
          onChange={(e: any) => inputFieldChangeHandler(e)}
          onKeyPress={(e: any) => {
            if (e.key === "Enter") addListItemHandler();
          }}
          value={inputValue}
          type="text"
          inAdvancedSearch={true}
          placeholder="Sites(Amazon.com), TLD(*.in)"
          idInput="exclude-input"
        />
        &nbsp;&nbsp;
        <Button disabled={inputValue.length === 0 ? true : false} onClick={addListItemHandler} className="exclude">Exclude</Button>
      </div>
      {error ? <p className="error-msg-style">{errorMsg}</p> : null}
      {subTextWithInfoIcon ? (
        <div className="d-flex align-items-start">
          <img src={Info} className="info-img-subtext" alt="" />
          <p className="info-tag-subtext" >{subTextWithInfoIcon}</p>
        </div>
      ) : null}
      {showConfirm && (
        <ConfirmDialog
          inAdvancedSearch={true}
          excludeSource={true}
          confirm="Yes"
          cancel="No"
          onConfirm={handleDeleteAllListItems}
          onCancel={handleCancelDeleteAllListItems}
          title="Selected excluded sources will be removed."
          titleQuestion="Are you sure?"
        />
      )}
    </Wrapper>
  );
};

export default ExcludeContent;

const Wrapper = styled.div<{ showSearchField: boolean }>`
.not-label label {
  display: none !important;
}
.ant-btn[disabled]{
  opacity: 0.6 !important;
}
.exclude {
  border-radius: 8px;
  font-family: Roboto;
  background: #27ce0a;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  height: auto;
  max-width: 85px;
  line-height: 20px;
}
@media (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
  .exclude {
    font-size: 12px !important;
  }
}
  background-color: #f8f8f8;
  border-radius: 13px;
  margin-top: 26px;
  padding: 20px;
  position: relative;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding: 16px;
  }
  .disable-item {
    pointer-events: none;
    opacity: 0.5;
  }
  .heading {
    font-weight: 500;
    font-size: 14px !important;
    font-family: Roboto;
    line-height: normal;
    color: #424b50;
    margin: 0;
    display: flex;
    align-items: center
  }
  .search-cover {
    margin-left: 16px;
    border-radius: 50%;
    background-color: #fff;
    padding: 4px 4px 4px 4px;
    border: 1px solid #dadada;
    display: inline-flex;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-left: 8px;
    }
  }
  .open-search {
    position: relative;
    width: 250px;
    margin-left: 10px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 175px;
      margin-top: 2px;
    }
    .cross {
      margin-top: 0px;
      @media all and (min-width: 1920px), (min-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        bottom: 0.6em !important;
      }
    }
    > label {
      margin: 0;
      display: none;
    }
    .reload {
      border-right: 1px solid #dddddd;
      position: absolute;
      left: 0.8em;
      top: 5px;
      z-index: 9;
      height: 13px;
      padding-right: 5px;
      @media all and (min-width: 1920px), (min-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        top: 3px !important;
      }
    }
    input {
      border-radius: 15px;
      height: 31px;
      width: 100%;
      padding-left: 35px;
    }
  }
  .green-text {
    font-weight: 700;
    font-size: 14px;
    color: #1ec252;
    display: inline;
    margin: 0;
    display: inline-block;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 11px;
      letter-spacing: -0.25px;
    }
    &:hover {
      cursor: pointer;
    }
  }
  .red-text {
    font-weight: 700;
    font-size: 14px;
    color: #9f0000;
    display: inline;
    margin: 0;
    display: inline-block;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 11px;
      letter-spacing: -0.25px;
    }
    &:hover {
      cursor: pointer;
    }
  }
  .list {
    background-color: "blue";
    max-height: 128px;
    overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: #001760 transparent;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row-reverse;
    ul {
      padding-left: 0px;
      margin: 0;
      li {
        line-height: 1.8;
        label input + span {
          width: 22px;
          height: 22px;
          margin-bottom: -5px;
        }
        .text-style {
          max-width: 250px;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          word-break: break-all;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-right: 5px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            max-width: 150px;
          }
        }
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          line-height: 2.1;
        }
      }
    }
    .list-count {
      color: #7e7e7e;
      font-family: "Roboto Slab";
      font-size: 14px;
      font-weight: 700;
    }
    .ai-content-text-style {
      color: #424b50;
      font-size: 14px;
      font-family: "Roboto";
      font-weight: 600;
    }
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 5px;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: #fff;
      margin-top: 10px;
      margin-bottom: 15px;
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #001760;
    }
    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
    ul {
      list-style-type: none;
    }
    li {
      display: flex;
      align-items: center;
    }
  }
  .error-msg-style {
    color: #db3725;
    font-size: 12px;
  }
  .info-img-subtext {
    width: 12px;
    margin-top: 12px;
    margin-right: 6px;
    opacity: 0.6;
  }
  .info-tag-subtext {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: -0.5px;
    color: #A0A0A0;
    margin-bottom: 0px;
    margin-top: 10px;
    white-space: pre-wrap;
    opacity: 0.6;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
    }
  }  
`;
